<batch-notification
  [header]="isIsf ? 'SOME_OF_THE_ITEMS_HAVENT_SUCCESSFULLY_CONVERTED_TO_ISFS' : 'SOME_OF_THE_ITEMS_HAVENT_SUCCESSFULLY_CONVERTED_TO_ES'"
  hint="THERE_WAS_AN_ERROR_WHILE_UPLOADING_SOME_OF_ITEMS_IN_ERP_REPORT"
  isShowReload="true"
  [downloadUrl]="batchItem.fileReference"
  (reload)="onReload()"
></batch-notification>
